<template>
  <div
    class="w-full flex bg-gray-200 px-4 py-2 border rounded border-gray-800 mb-4"
  >
    <div class="flex-1">
      <p class="w-full">
        {{ companies.join(", ") }}
        <span class="text-sm text-gray-700" v-if="filter">{{ filter }}</span>
      </p>
      <p class="w-full text-sm" v-if="data.monthly">Monthly</p>
      <p class="w-full text-sm" v-else>
        {{ startDate.format("MMM DD 'YY") }} -
        {{ endDate.format("MMM DD 'YY") }}
      </p>
    </div>
    <div class="flex-shrink-0 flex items-center">
      <font-awesome-icon
        class="cursor-pointer mr-4"
        :icon="['fas', 'pencil-alt']"
        @click="showUpdate"
      />
      <font-awesome-icon
        class="cursor-pointer"
        :icon="['fas', 'trash']"
        @click="deleteSetting"
      />
    </div>
  </div>
</template>

<script>
import { map } from "lodash"
import moment from "moment"
import UpdateForm from "./UpdateForm"
import { EventBus } from "../events"

export default {
  name: "BudgetSettingItem",
  props: {
    data: {
      required: true,
    },
    allCompanies: {
      required: true,
    },
  },
  computed: {
    companies() {
      return map(this.data.companies, (item) => item.name)
    },
    startDate() {
      return moment(this.data.start_date)
    },
    endDate() {
      return moment(this.data.end_date)
    },
    filter() {
      if (!this.data.campaign_filter) return null
      if (this.data.campaign_filter_operator === "contains")
        return '(only "' + this.data.campaign_filter + '")'
      else return '(not "' + this.data.campaign_filter + '")'
    },
  },
  methods: {
    showUpdate() {
      this.$modal.show(
        UpdateForm,
        {
          companies: this.allCompanies,
          existing: this.data,
        },
        {
          width: 800,
          height: "auto",
          scrollable: true,
        }
      )
    },
    deleteSetting() {
      let r = confirm(
        "This will delete the Budget setting and all of it's corresponding items. This cannot be undone. Continue?"
      )
      if (r == true) {
        this.axios.post("budget/destroy/" + this.data.id).then(() => {
          EventBus.$emit("fetch-settings")
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
